import React from 'react'
import { checkTextTranslation } from '../../utils/useful'

class TextInput extends React.Component {
    state = {
    }

    componentDidMount(){
        console.log('this.props.header.key',this.props.header.key);
        if(this.props.header.key == 'tempAddress'){
            if(this.props.data){

            this.setState({inrental: true})
        }
        
    }
}
enterToGo = (e) => {
    // console.log('eeee.kkkkkkkkk',e.key,e.which);
    if(this.props.header.key == 'tempAddress'){
        if (e.which == 81 || e.key == "q") {
            this.props.changeValue(this.props.header.key, null, this.props.extra)
            this.setState({inrental: false})

        }
      }
      }
 

    changeInputValue(target) {
        let value = (target.validity.valid) ? target.value : null
        if (value !== null) {
            this.props.changeValue(this.props.header.key, value, this.props.extra)
        }
    }


    render() {
        return (
            <div className="w-100 h-100">
                <input  ref={el => this.input = el}  onKeyDown={(e) => this.enterToGo(e)} spellCheck={this.props.header.information.spellCheck} value={this.state.inrental ? 'In Rental':this.props.data ? this.props.data : ''} onChange={(e) => this.changeInputValue(e.target)} placeholder={checkTextTranslation(this.props.header.information.placeholder)} disabled={this.props.disabled || this.props.header.information?.disabled} className="transpanet-input" />
            </div>
        )
    }
}

export default TextInput;